/* IncidentMapModal.js for REACT 18, Bootstrap 5, Map Modal with map- prefixes - 06-23-25 */
/* THIS IS CALLED A FUNCTIONAL COMPONENT AND WILL BE DIFFERENT FROM THE OTERH UNTIL THEY CAN BE UPDATED */
/* THAT MEANS IT USES USE EFFECT AND useRef.. and the other ones dont */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideModal } from '../../actions/modal';
import MapNewGoogle from '../MapNewGoogle/MapNewGoogle';
import './IncidentMapModal.css';

const IncidentMapModal = ({ modalProps = {}, visible, hideModal }) => {
  const modalRef = useRef(null);
  const incident = modalProps.incident || {};

  console.log('at inc map modal in render to see what props are on incident', { modalProps, incident, visible });

  // Minimal useEffect for backdrop click
  useEffect(() => {
    const modalElement = modalRef.current;
    if (modalElement && visible) {
      const handleBackdropClick = (e) => {
        if (e.target === modalElement && hideModal) {
          console.log('Backdrop clicked, closing IncidentMapModal');
          hideModal();
        }
      };
      modalElement.addEventListener('click', handleBackdropClick);
      return () => {
        modalElement.removeEventListener('click', handleBackdropClick);
      };
    }
  }, [visible, hideModal]);

  if (!visible) {
    console.log('IncidentMapModal not visible, returning null');
    return null;
  }

  const coordinatePoints = {
    coordinates: {
      lat: incident.coordinate?.latitude || 0,
      lng: incident.coordinate?.longitude || 0,
    },
    location: incident.location_description_translation?.en_US || incident.location || 'N/A',
    type: incident.incident_type_translation?.en_US || incident.incident_type || 'Unknown',
    received: incident.received || '',
    occurred: incident.occurred || '',
    name: incident.agency_id || '',
    incident_number: incident.display_title || '',
    color: '#1033e4',
  };

  const centerpoint = {
    lat: incident.coordinate?.latitude || 0,
    lng: incident.coordinate?.longitude || 0,
  };

  return (
    <div>
      {/* Backdrop */}
      <div className="map-modal-backdrop fade show" />
      {/* Modal */}
      <div
        className={`map-modal ${visible ? 'show' : ''}`}
        id="map-modal"
        ref={modalRef}
        style={{ display: visible ? 'block' : 'none' }}
      >
        <div className="map-modal-dialog">
          <div className="map-modal-content">
            <div className="map-modal-header">
              <h5 className="map-modal-title">
                <i className="material-icons">map</i>
                <span className="image-text">
                  Incident GPS Location - <span className="display-title">{incident.display_title || 'Incident'}</span>{incident.title ? ` - ${incident.title}` : ''}
                </span>
              </h5>
              <button type="button" className="map-modal-close-button" onClick={hideModal}>
                Close X
              </button>
            </div>
            <div className="map-modal-body" id="map-modal-body">
              <MapNewGoogle coords={coordinatePoints} center={centerpoint} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

IncidentMapModal.propTypes = {
  modalProps: PropTypes.object,
  visible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func,
};

export default connect(null, { hideModal })(IncidentMapModal);